/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import validate from 'validate.js';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Button, TextField, Typography, Grid2,  Select } from '@mui/material';
import useRouter from 'utils/useRouter';
import { SetFormState } from '../../../../../../actions/OperatorsActions';
import SelectField from '../../../../../../../../components/SelectField/SelectField.js';

const schema = {
	name: {
		presence: { allowEmpty: false, message: 'is required' },
	},
};

const useStyles = makeStyles((theme) => ({
	root: {},
	fields: {
		margin: theme.spacing(-1),
		display: 'flex',
		flexWrap: 'wrap',
		'& > *': {
			flexGrow: 1,
			margin: theme.spacing(1),
		},
	},
	submitButton: {
		marginTop: theme.spacing(2),
		width: '100%',
	},
}));

const AddOperatorForm = (props) => {
	const { className, ...rest } = props;

	const classes = useStyles();
	const router = useRouter();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.operatorsReducer.formState);

	useEffect(() => {
		const errors = validate(formState.values, schema);

		setFormState({
			...formState,
			isValid: !errors,
			errors: errors || {},
		});
	}, [formState.values]);

	const handleChange = (event) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value,
			},
			touched: {
				...formState.touched,
				[event.target.name]: true,
			},
		});
	};

	const hasError = (field) => (!!(formState.touched[field] && formState.errors[field]));
	return (
		<div className={classes.fields}>
			<Grid2 container spacing={4}>
				<Grid2 item size={12}>
					<TextField
						error={hasError('name')}
						fullWidth
						helperText={
							hasError('name') ? formState.errors.name[0] : null
						}
						label="Name"
						name="name"
						onChange={handleChange}
						value={formState.values.name || ''}
						variant="outlined"
					/>
				</Grid2>
			</Grid2>
		</div>

	);
};

AddOperatorForm.propTypes = {
	className: PropTypes.string,
};

export default AddOperatorForm;
